import { noop, type QueryClient } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { requireAuthedUser } from "@/auth/session";
import { query } from "@/queries";
import { AppLayout } from "@/shell/AppLayout";

function warmCache(queryClient: QueryClient) {
  const warm = () => {
    void queryClient.query(query.catalogs.technologies()).catch(noop);
    void queryClient.query(query.catalogs.advancedTechnologies()).catch(noop);
    void queryClient.query(query.catalogs.fleetTechnologies()).catch(noop);
    void queryClient.query(query.catalogs.crops()).catch(noop);
    void queryClient.query(query.catalogs.varieties(null)).catch(noop);
    void queryClient.query(query.customers.accounts()).catch(noop);
    void queryClient.query(query.johnDeere.allConnections()).catch(noop);
  };
  // Safari has no requestIdleCallback.
  if ("requestIdleCallback" in window) requestIdleCallback(warm);
  else setTimeout(warm, 1000);
}

/** Pathless layout that guards everything nested under it. */
export const Route = createFileRoute("/_authed")({
  beforeLoad: ({ context }) => requireAuthedUser(context.queryClient),
  onEnter: ({ context }) => warmCache(context.queryClient),
  component: AppLayout,
});
